import React, { useCallback, useEffect, useRef, useState } from "react";

interface Dimensions {
  width: number;
  height: number;
}
const initialState: Dimensions = { width: 0, height: 0 };

export function useDimension<T extends Element>(
  ref: React.MutableRefObject<T>
) {
  const [dimensions, setDimensions] = useState(initialState);
  const handlersRef = useRef<((d: Dimensions) => void)[]>([]);
  const resizeObserverRef = useRef<ResizeObserver>();

  const setHandler = useCallback((handler: (d: Dimensions) => void) => {
    handlersRef.current[0] = handler;
  }, []);

  useEffect(() => {
    let isMounted = true;
    resizeObserverRef.current = new ResizeObserver((entries = []) => {
      if (!isMounted) return;
      entries.forEach((entry) => {
        const { width, height } = entry.contentRect;
        const d = { width, height };
        setDimensions(d);
        handlersRef.current.forEach((h) => h(d));
      });
    });
    if (ref.current) resizeObserverRef.current.observe(ref.current);

    return () => {
      isMounted = false;
      if (resizeObserverRef.current && ref.current) {
        resizeObserverRef.current.unobserve(ref.current);
        resizeObserverRef.current.disconnect();
      }
    };
  }, []);

  return {
    ...dimensions,
    setHandler,
  };
}
